import { useAuth } from '../auth/useAuth'
import { Button } from './ui'

function AuthButton() {
  const { isAuthenticated, isLoading, user, logout } = useAuth()

  if (isLoading) {
    return (
      <div className="h-10 w-24 bg-neutral-200 rounded-md animate-skeleton-pulse" />
    )
  }

  if (isAuthenticated) {
    return (
      <div className="flex items-center gap-3">
        <span className="text-neutral-700 font-medium">
          {user?.name}
        </span>
        <Button
          variant="secondary"
          size="sm"
          onClick={logout}
        >
          Logout
        </Button>
      </div>
    )
  }

  // GoogleAdapter renders a full-screen login gate when the user is not
  // authenticated, so the unauthenticated branch of this button is unreachable
  // in practice. Return null defensively.
  return null
}

export default AuthButton
